import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="category-cards"
export default class extends Controller {
  static targets = ["card", "toggleButton", "buttonText"]
  static values = { initialCount: { type: Number, default: 4 } }

  connect() {
    // Check localStorage for saved state, default to collapsed (false)
    this.isExpanded = this.getSavedState()
    this.updateVisibility()
    this.updateButton()
  }

  toggle() {
    this.isExpanded = !this.isExpanded
    this.saveState()
    this.updateVisibility()
    this.updateButton()
  }

  updateVisibility() {
    this.cardTargets.forEach((card, index) => {
      if (this.isExpanded || index < this.initialCountValue) {
        card.style.display = ""
      } else {
        card.style.display = "none"
      }
    })
  }

  updateButton() {
    if (!this.hasToggleButtonTarget) return

    const hiddenCount = this.cardTargets.length - this.initialCountValue
    
    if (this.isExpanded) {
      this.buttonTextTarget.textContent = "Show less"
    } else {
      this.buttonTextTarget.textContent = `Show ${hiddenCount} more`
    }
  }

  getSavedState() {
    try {
      const saved = localStorage.getItem('timehub-stats-cards-expanded')
      // Default to false (collapsed) if no saved state
      return saved === 'true'
    } catch (error) {
      console.warn('Could not read stats cards state from localStorage:', error)
      return false
    }
  }

  saveState() {
    try {
      localStorage.setItem('timehub-stats-cards-expanded', this.isExpanded.toString())
    } catch (error) {
      console.warn('Could not save stats cards state to localStorage:', error)
    }
  }

  async showCategoryDetails(event) {
    event.preventDefault()
    const categoryId = event.currentTarget.dataset.categoryId
    
    try {
      // Fetch the category details as HTML
      const response = await fetch(`/categories/${categoryId}`, {
        headers: {
          'Accept': 'text/html',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      
      if (response.ok) {
        const html = await response.text()
        
        // Insert the modal HTML into the container
        const container = document.getElementById('category-modal-container')
        if (container) {
          container.innerHTML = html
          
          // Find and show the modal
          const modal = container.querySelector('[data-controller="category-show-modal"]')
          if (modal) {
            console.log('Found modal:', modal)
            
            // Initialize Stimulus controller if needed
            if (window.Stimulus) {
              window.Stimulus.load(modal)
            }
            
            // Show the modal
            modal.classList.remove('hidden')
            document.body.style.overflow = 'hidden'
            
            console.log('Modal classes after show:', modal.classList.toString())
          } else {
            console.log('Modal not found in container')
            console.log('Container content:', container.innerHTML.substring(0, 200))
          }
        }
      } else {
        console.error("Failed to load category details")
      }
    } catch (error) {
      console.error("Error loading category details:", error)
    }
  }
}